import { Card } from '@etg/wings';
import { DangerousHtmlContent, Overlay } from '@eti/components';

export interface RefundProcessOverlayProps {
  isOpen: boolean;
  onClose: () => void;
  refundProcessDescription: string;
  refundProcessHeaderText: string;
}

const RefundProcessOverlay = ({
  isOpen,
  onClose,
  refundProcessDescription,
  refundProcessHeaderText,
}: RefundProcessOverlayProps) => (
  <Overlay.Drawer dataTestId="refundProcess-overlay" handleClose={onClose} isOpen={isOpen}>
    <Overlay.Header onClose={onClose} title={refundProcessHeaderText} />
    <Overlay.Content data-testid="refundProcess-overlay-content">
      <Card>
        <DangerousHtmlContent content={refundProcessDescription} />
      </Card>
    </Overlay.Content>
  </Overlay.Drawer>
);

export default RefundProcessOverlay;
